import(/* webpackMode: "eager" */ "/source/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/source/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/source/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/[pageCode]/cms.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/contentLand/content.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/nothing/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V2/components/BestSellers.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V2/components/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-carousel-small/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-carousel-small/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-category-floor/compoments/BigImg/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-category-floor/compoments/BigImg/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-category-floor/img/cart.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-category-floor/img/default_white.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-category-floor/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-category-floor/style.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CountdownBar.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CouponContent.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CouponList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/ScrollContainer.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/SVGScrollController.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkAllClaimed.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkCollected.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkEnded.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkNotStarted.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/style.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CouponList.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/ScrollContainer.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-delivery/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-demo/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/saleTips.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/tips.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/saleTips.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/tips.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-hotspot/style.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image-ads/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image-ads/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-new-arrival_V2/newArrivals.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-new-arrival_V2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer_V2/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-gift/gift.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-gift/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-land/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-land/src/components/productList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-land/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer_V2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-popular-categoryV2/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-popular-categoryV2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-recommend-product/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/icon/ShoppingSeckill.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/icon/VectorSeckill.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/src/assets/empty.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/src/components/productList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/src/components/reservationBtns.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/src/components/reservationBtns.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/src/components/tabBar.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-seckill/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default","getInstance"] */ "/source/src/app/login/index.login.ts");
;
import(/* webpackMode: "eager" */ "/source/src/assets/icons/chevron-down.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorTryAgain"] */ "/source/src/components/error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/SafeLink.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/i18n/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["JDILogin","getInstance"] */ "/source/src/lib/jdiClientUtils.ts");
